import { render, staticRenderFns } from "./SocialliteLogin.vue?vue&type=template&id=3640c4df"
import script from "./SocialliteLogin.vue?vue&type=script&lang=js"
export * from "./SocialliteLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports